import {ValueObject} from '@s-ui/domain'

export class StatsResponseValueObject extends ValueObject {
  /**
   * @param {Array<id: string, type: string, value: string|number>} stats
   */
}
